import { statusMeta } from "@/lib/marketStatus";
import { dateOnly, eur } from "@/lib/format";

export const MarketStatusBadge = ({ status, testid }) => {
  const meta = statusMeta(status);
  const Icon = meta.icon;
  return (
    <span className={`chip ${meta.chip}`} data-testid={testid}>
      <Icon className="h-3 w-3" />
      {meta.label}
    </span>
  );
};

export const MakeMonogram = ({ label, size = "md" }) => {
  const initials = (label || "?")
    .split(/[\s-]+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full border border-slate-300 bg-slate-100 font-display font-bold text-slate-700 ${
        size === "sm" ? "h-5 w-5 text-[9px]" : "h-7 w-7 text-[10px]"
      }`}
    >
      {initials}
    </span>
  );
};

export const PriceDropCell = ({ market, testid }) => {
  const change = market?.price_change;
  if (change === null || change === undefined || change === 0) {
    return <span className="text-[12px] text-slate-300">-</span>;
  }
  const down = change < 0;
  return (
    <div data-testid={testid}>
      <span
        className={`chip ${
          down
            ? "border-red-300 bg-red-50 text-red-700"
            : "border-slate-300 bg-slate-50 text-slate-600"
        } mono`}
      >
        {down ? "−" : "+"} {eur(Math.abs(change))}
      </span>
      {market?.price_change_at && (
        <div className="mt-0.5 text-[9.5px] text-slate-500">
          {dateOnly(market.price_change_at)}
          {market.previous_price ? ` · was ${eur(market.previous_price)}` : ""}
        </div>
      )}
    </div>
  );
};
